<template>
  <div id="app">
    <template>
      <headerCom />
      <div ref="middle" class="main-box">
        <main>
          <router-view />
          <!-- <CompanyIntroduce/>
          <pipeline /> -->
        </main>
        <footerCom />
      </div>
    </template>
  </div>
</template>

<script>
import headerCom from "@/views/components/headerCom";
import footerCom from "@/views/components/footerCom";
// import CompanyIntroduce from '@/views/AbouUs/CompanyIntroduce.vue'
// import pipeline from '@/views/ProductDevelopment/pipeline.vue'
export default {
  name: "APP",
  components: {
    headerCom,
    // CompanyIntroduce,
    // pipeline
    footerCom,
  },
  provide() {
    return {
      goBottom: this.goBottom,
      goTop: this.goTop,
    };
  },
  data() {
    return {
      ua: navigator.userAgent.toLocaleLowerCase(),
    };
  },
  watch: {
    $route(route) {
      console.log("route", route);
    },
  },
  created() {
    if (this.ua.match(/msie/) != null || this.ua.match(/trident/) != null) {
      this.browserType = "IE";
      this.$router.push(`/ie`);
    }
    const accessToken = new URLSearchParams(location.search).get(
      "access_token"
    );
    if (accessToken) {
      // this.$store.dispatch('saveToken', accessToken)
      sessionStorage.setItem("token", accessToken);
    } else {
      // this.$store.dispatch('saveToken', '')
      // this.$store.dispatch('saveUserInfo', {
      //   // 'address': "苏州市人民路1058号",
      //   // 'id': 95,
      //   // 'idNumber': "230205198911200225",
      //   // 'idNumberType': "1",
      //   // 'name': "刘丽辉",
      //   // 'orgId': 30,
      //   // 'role': '2',
      //   // 'orgName': "苏州市安居经营服务有限公司",
      //   // 'phone': "051265098628"
      // })
    }
  },
  methods: {
    goBottom() {
      this.$nextTick(() => {
        const middle = this.$refs["middle"];
        middle.scrollTop = middle.scrollHeight;
      });
    },
    goTop() {
      this.$nextTick(() => {
        const middle = this.$refs["middle"];
        middle.scrollTop = 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  width: 100%;
  min-width: 1400px;
  overflow: auto;
}
#app {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #000;
  font-size: 16px;
  background-color: #f8fafb;
}

.main-box {
  width: 100%;
  flex: 1;
  overflow: overlay;
  display: flex;
  flex-flow: column;

  &::-webkit-scrollbar {
    height: 0 !important;
    width: 0 !important;
  }
}

main {
  width: 100%;
  position: relative;
  margin: 0 auto;
  flex: 1;
}

.viewer-title {
  display: none !important;
}
</style>
